/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VariableSettingErrorDto } from './variableSettingErrorDto';
import { UpdatedVariableSettingDto } from './updatedVariableSettingDto';


export interface UpdateVariableSettingsResponse { 
    variables?: Array<UpdatedVariableSettingDto>;
    errors?: Array<VariableSettingErrorDto>;
    gea_puid?: string;
}

